import type { ReactNode } from 'react';

export default function Eyebrow({ children, light = false }: { children: ReactNode; light?: boolean }) {
  return (
    <p className={`text-[12px] tracking-[0.18em] uppercase font-medium ${light ? 'text-background-50/80' : 'text-foreground-600'}`}>
      {children}
    </p>
  );
}